import { baseApi } from "./baseApi";

const loanClosingCostsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLoanClosingCosts: builder.query({
      query: (loanId) => ({
        url: `/loans/${loanId}/closing-costs`,
        method: "GET",
      }),
      providesTags: (result, error, loanId) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
    runFees: builder.mutation({
      query: (loanId) => ({
        url: `/loans/${loanId}/fees`,
        method: "POST",
      }),
      invalidatesTags: (result, error, loanId) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
    createClosingCost: builder.mutation({
      query: ({ loanId, data }) => ({
        url: `/loans/${loanId}/closing-costs`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
    patchClosingCost: builder.mutation({
      query: ({ loanId, closingCostId, data }) => ({
        url: `/loans/${loanId}/closing-costs/${closingCostId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
    deleteClosingCost: builder.mutation({
      query: ({ loanId, closingCostId }) => ({
        url: `/loans/${loanId}/closing-costs/${closingCostId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
    saveClosingCostChanges: builder.mutation({
      query: ({ loanId, data }) => ({
        url: `/loans/${loanId}/closing-costs/batch-save`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result, error, { loanId }) => [
        { type: "LoanClosingCosts", id: loanId },
      ],
    }),
  }),
});

export default loanClosingCostsApi;
